import React from 'react';
import PropTypes from 'prop-types';

function Select(props) {
  let labelClass = 'form__desc-label';

  if (props.helpText) {
    labelClass += ' form__desc-label--no-spacing';
  }

  return (
    <div className="form__group" data-required={props.required}>
      { props.label ? <label className={labelClass}><strong>{props.label}</strong></label> : null }
      {
        props.helpText ?
        <small className="form__help-text">{props.helpText}</small> : null
      }
      <div className="select-wrapper">
        <select {...props}>
          {props.children}
        </select>
        <div className="select-wrapper__icon"></div>
      </div>
    </div>
  );
}

Select.propTypes = {
  label: PropTypes.string,
  children: PropTypes.any,
};

export default Select;
